import { render, staticRenderFns } from "./no-recommendation.html?vue&type=template&id=6fde40bd&"
import script from "./no-recommendation.vue?vue&type=script&lang=js&"
export * from "./no-recommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports